import { render, staticRenderFns } from "./NewGate.vue?vue&type=template&id=68a31b6a&scoped=true"
import script from "./NewGate.vue?vue&type=script&lang=js"
export * from "./NewGate.vue?vue&type=script&lang=js"
import style0 from "./NewGate.vue?vue&type=style&index=0&id=68a31b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a31b6a",
  null
  
)

export default component.exports